/* eslint-disable max-lines */
/* eslint-disable quote-props */
/* eslint-disable quotes */
export const AUDIENCE_MAP = {
  "Apparel & Accessories": _TL_("Apparel & Accessories"),
  "Autos & Vehicles": _TL_("Autos & Vehicles"),
  "Business Owner": _TL_("Business Owner"),
  "Home & Garden": _TL_("Home & Garden"),
  "Home & Garden Services": _TL_("Home & Garden Services"),
  "Home Inspection Services": _TL_("Home Inspection Services"),
  "Job Title": _TL_("Job Title"),
  "Consultant": _TL_("Consultant"),
  "Real Estate": _TL_("Real Estate"),
  "Residential Properties": _TL_("Residential Properties"),
  "Residential Properties (For Rent)": _TL_("Residential Properties (For Rent)"),
  "Sports & Fitness": _TL_("Sports & Fitness"),
  "Business and Industrial": _TL_("Business and Industrial"),
  "Agriculture": _TL_("Agriculture"),
  "Building Construction and Maintenance": _TL_("Building Construction and Maintenance"),
  "Building Materials and Supplies": _TL_("Building Materials and Supplies"),
  "Hardware Tools and Accessories": _TL_("Hardware Tools and Accessories"),
  "Business Management": _TL_("Business Management"),
  "Advertising and Marketing": _TL_("Advertising and Marketing"),
  "Design and Engineering": _TL_("Design and Engineering"),
  "Food Service Industry": _TL_("Food Service Industry"),
  "Industrial Goods and Manufacturing": _TL_("Industrial Goods and Manufacturing"),
  "Industrial Manufacturing": _TL_("Industrial Manufacturing"),
  "Metals": _TL_("Metals"),
  "Precious Metals": _TL_("Precious Metals"),
  "Office": _TL_("Office"),
  "Business Cards, Stationery and Forms": _TL_("Business Cards, Stationery and Forms"),
  "Office Appliances": _TL_("Office Appliances"),
  "Desktop Printers": _TL_("Desktop Printers"),
  "Retail Trade": _TL_("Retail Trade"),
  "Computers and Consumer Electronics": _TL_("Computers and Consumer Electronics"),
  "Computers": _TL_("Computers"),
  "Computer Hardware": _TL_("Computer Hardware"),
  "Software": _TL_("Software"),
  "Business and Productivity Software": _TL_("Business and Productivity Software"),
  "E-Commerce and Retail Software": _TL_("E-Commerce and Retail Software"),
  "Device Drivers": _TL_("Device Drivers"),
  "Graphics and Multimedia Software": _TL_("Graphics and Multimedia Software"),
  "Internet Software and Web Goodies": _TL_("Internet Software and Web Goodies"),
  "Network Security Software": _TL_("Network Security Software"),
  "Anti-Virus Software": _TL_("Anti-Virus Software"),
  "Web Browsers": _TL_("Web Browsers"),
  "Consumer Electronics": _TL_("Consumer Electronics"),
  "Dining and Nightlife": _TL_("Dining and Nightlife"),
  "Dining and Nightlife Reviews, Guides and Listings": _TL_("Dining and Nightlife Reviews, Guides and Listings"),
  "Restaurants": _TL_("Restaurants"),
  "Restaurant Take-out and Delivery": _TL_("Restaurant Take-out and Delivery"),
  "Family and Community": _TL_("Family and Community"),
  "Community Service and Social Organizations": _TL_("Community Service and Social Organizations"),
  "Romance and Relationships": _TL_("Romance and Relationships"),
  "Finance": _TL_("Finance"),
  "Accounting and Auditing": _TL_("Accounting and Auditing"),
  "Tax Preparation and Planning": _TL_("Tax Preparation and Planning"),
  "Credit and Lending": _TL_("Credit and Lending"),
  "Credit Cards": _TL_("Credit Cards"),
  "Loans": _TL_("Loans"),
  "Insurance": _TL_("Insurance"),
  "Health Insurance": _TL_("Health Insurance"),
  "Supplemental Health Insurance": _TL_("Supplemental Health Insurance"),
  "Vehicle Insurance": _TL_("Vehicle Insurance"),
  "Car Insurance": _TL_("Car Insurance"),
  "Investing": _TL_("Investing"),
  "Food and Groceries": _TL_("Food and Groceries"),
  "Food": _TL_("Food"),
  "Health": _TL_("Health"),
  "Health Care Services": _TL_("Health Care Services"),
  "Health Conditions and Concerns": _TL_("Health Conditions and Concerns"),
  "Digestive Health and Disorders": _TL_("Digestive Health and Disorders"),
  "Headache and Pain Management": _TL_("Headache and Pain Management"),
  "Pharmacy": _TL_("Pharmacy"),
  "Hobbies and Leisure": _TL_("Hobbies and Leisure"),
  "Antiques and Collectibles": _TL_("Antiques and Collectibles"),
  "Pets and Animals": _TL_("Pets and Animals"),
  "Toys and Games": _TL_("Toys and Games"),
  "Games": _TL_("Games"),
  "Card Games": _TL_("Card Games"),
  "Online Games and Puzzles": _TL_("Online Games and Puzzles"),
  "Table Games": _TL_("Table Games"),
  "Pool and Billiards": _TL_("Pool and Billiards"),
  "Video Games, Consoles and Accessories": _TL_("Video Games, Consoles and Accessories"),
  "Computer and Video Games": _TL_("Computer and Video Games"),
  "Casual Games": _TL_("Casual Games"),
  "Free-To-Play Games": _TL_("Free-To-Play Games"),
  "Toys": _TL_("Toys"),
  "Children's Dolls, Dress-Up Toys and Costumes": _TL_("Children's Dolls, Dress-Up Toys and Costumes"),
  "Online Doll Dress-Up and Girl Games": _TL_("Online Doll Dress-Up and Girl Games"),
  "Home and Garden": _TL_("Home and Garden"),
  "Home Decor and Interior Decorating": _TL_("Home Decor and Interior Decorating"),
  "Home Furniture": _TL_("Home Furniture"),
  "Kitchen and Dining": _TL_("Kitchen and Dining"),
  "Yard, Garden and Patio": _TL_("Yard, Garden and Patio"),
  "Yard and Garden Equipment and Supplies": _TL_("Yard and Garden Equipment and Supplies"),
  "Internet and Telecom": _TL_("Internet and Telecom"),
  "Internet": _TL_("Internet"),
  "Telephony": _TL_("Telephony"),
  "Jobs and Education": _TL_("Jobs and Education"),
  "Education and Training": _TL_("Education and Training"),
  "Jobs and Careers": _TL_("Jobs and Careers"),
  "Job Listings": _TL_("Job Listings"),
  "Retail Jobs": _TL_("Retail Jobs"),
  "Law and Government": _TL_("Law and Government"),
  "Legal": _TL_("Legal"),
  "Occasions and Gifts": _TL_("Occasions and Gifts"),
  "Cards and Greetings": _TL_("Cards and Greetings"),
  "Gifts": _TL_("Gifts"),
  "Gift Delivery": _TL_("Gift Delivery"),
  "Real Estate Listings": _TL_("Real Estate Listings"),
  "Bank-Owned and Foreclosed Listings": _TL_("Bank-Owned and Foreclosed Listings"),
  "Rental Listings": _TL_("Rental Listings"),
  "Apartment Rentals": _TL_("Apartment Rentals"),
  "Retailers and General Merchandise": _TL_("Retailers and General Merchandise"),
  "Coupons and Rebates": _TL_("Coupons and Rebates"),
  "Sports and Fitness": _TL_("Sports and Fitness"),
  "Sporting Goods": _TL_("Sporting Goods"),
  "Sports": _TL_("Sports"),
  "Travel and Tourism": _TL_("Travel and Tourism"),
  "Accommodations": _TL_("Accommodations"),
  "Hotels, Motels and Resorts": _TL_("Hotels, Motels and Resorts"),
  "Hotels": _TL_("Hotels"),
  "Resorts": _TL_("Resorts"),
  "Vacation Rentals": _TL_("Vacation Rentals"),
  "Air Travel": _TL_("Air Travel"),
  "Airline Tickets, Fares and Flights": _TL_("Airline Tickets, Fares and Flights"),
  "Cruises and Cruise Services": _TL_("Cruises and Cruise Services"),
  "Last Minute Travel": _TL_("Last Minute Travel"),
  "Last Minute Airfares and Flights": _TL_("Last Minute Airfares and Flights"),
  "Specialty Travel": _TL_("Specialty Travel"),
  "Tourist Attractions and Destinations": _TL_("Tourist Attractions and Destinations"),
  "Transportation and Excursions": _TL_("Transportation and Excursions"),
  "Car Rental Services": _TL_("Car Rental Services"),
  "Travel Booking Services": _TL_("Travel Booking Services"),
  "Travel Media and Publications": _TL_("Travel Media and Publications"),
  "City and Local Guides": _TL_("City and Local Guides"),
  "Vehicles": _TL_("Vehicles"),
  "Motor Vehicles": _TL_("Motor Vehicles"),
  "Cars and Trucks": _TL_("Cars and Trucks"),
  "Used Motor Vehicles": _TL_("Used Motor Vehicles"),
  "Vehicle Parts and Accessories": _TL_("Vehicle Parts and Accessories"),
  "Car Parts and Accessories": _TL_("Car Parts and Accessories"),
  "Replacement Car Parts": _TL_("Replacement Car Parts"),
  "Vehicle Tires and Tire Parts": _TL_("Vehicle Tires and Tire Parts"),
  "Car and Truck Tires": _TL_("Car and Truck Tires"),
  "Activewear": _TL_("Activewear"),
  "Running Apparel": _TL_("Running Apparel"),
  "Yoga Apparel": _TL_("Yoga Apparel"),
  "Backpacks": _TL_("Backpacks"),
  "Clothing": _TL_("Clothing"),
  "Apparel": _TL_("Apparel"),
  "Costumes": _TL_("Costumes"),
  "Eyewear": _TL_("Eyewear"),
  "Eyeglasses & Contact Lenses": _TL_("Eyeglasses & Contact Lenses"),
  "Sunglasses": _TL_("Sunglasses"),
  "Formal Wear": _TL_("Formal Wear"),
  "Bridal Wear": _TL_("Bridal Wear"),
  "Suits & Business Attire": _TL_("Suits & Business Attire"),
  "Handbags": _TL_("Handbags"),
  "Hats": _TL_("Hats"),
  "Jewelry & Watches": _TL_("Jewelry & Watches"),
  "Fine Jewelry": _TL_("Fine Jewelry"),
  "Necklaces": _TL_("Necklaces"),
  "Watches": _TL_("Watches"),
  "Wedding & Engagement Rings": _TL_("Wedding & Engagement Rings"),
  "Lingerie": _TL_("Lingerie"),
  "Luggage": _TL_("Luggage"),
  "Men's Apparel": _TL_("Men's Apparel"),
  "Outerwear": _TL_("Outerwear"),
  "Pants": _TL_("Pants"),
  "Perfumes & Fragrances": _TL_("Perfumes & Fragrances"),
  "Shirts & Tops": _TL_("Shirts & Tops"),
  "Shoes": _TL_("Shoes"),
  "Athletic Shoes": _TL_("Athletic Shoes"),
  "Boots": _TL_("Boots"),
  "Dress Shoes": _TL_("Dress Shoes"),
  "Socks": _TL_("Socks"),
  "Swimwear": _TL_("Swimwear"),
  "Underwear": _TL_("Underwear"),
  "Wallets, Briefcases & Leather Goods": _TL_("Wallets, Briefcases & Leather Goods"),
  "Wallets": _TL_("Wallets"),
  "Women's Apparel": _TL_("Women's Apparel"),
  "Women's Clothing": _TL_("Women's Clothing"),
  "Dresses": _TL_("Dresses"),
  "Arts & Crafts Supplies": _TL_("Arts & Crafts Supplies"),
  "Arts & Entertainment": _TL_("Arts & Entertainment"),
  "Comics & Graphic Novels": _TL_("Comics & Graphic Novels"),
  "Comic Strips": _TL_("Comic Strips"),
  "Manga": _TL_("Manga"),
  "Entertainment Industry": _TL_("Entertainment Industry"),
  "Film & TV Industry": _TL_("Film & TV Industry"),
  "TV Broadcasting": _TL_("TV Broadcasting"),
  "TV Shows & Programs": _TL_("TV Shows & Programs"),
  "TV Comedies": _TL_("TV Comedies"),
  "TV Game Shows": _TL_("TV Game Shows"),
  "TV Reality Shows": _TL_("TV Reality Shows"),
  "TV Talk Shows": _TL_("TV Talk Shows"),
  "Event Entertainment": _TL_("Event Entertainment"),
  "Movies & Films": _TL_("Movies & Films"),
  "Arts and Entertainment": _TL_("Arts and Entertainment"),
  "Movies and Films": _TL_("Movies and Films"),
  "Action & Adventure Films": _TL_("Action & Adventure Films"),
  "Superhero Films": _TL_("Superhero Films"),
  "Animated Films": _TL_("Animated Films"),
  "Bollywood & South Asian Film": _TL_("Bollywood & South Asian Film"),
  "Drama Films": _TL_("Drama Films"),
  "Musical Films": _TL_("Musical Films"),
  "Science Fiction & Fantasy Films": _TL_("Science Fiction & Fantasy Films"),
  "Music & Audio": _TL_("Music & Audio"),
  "Music and Audio": _TL_("Music and Audio"),
  "Classical Music": _TL_("Classical Music"),
  "Country Music": _TL_("Country Music"),
  "Dance & Electronic Music": _TL_("Dance & Electronic Music"),
  "Jazz & Blues": _TL_("Jazz & Blues"),
  "Blues": _TL_("Blues"),
  "Jazz": _TL_("Jazz"),
  "Music Videos": _TL_("Music Videos"),
  "Musical Instruments & Equipment": _TL_("Musical Instruments & Equipment"),
  "Drums & Percussion": _TL_("Drums & Percussion"),
  "Guitars": _TL_("Guitars"),
  "Pop Music": _TL_("Pop Music"),
  "Religious Music": _TL_("Religious Music"),
  "Christian & Gospel Music": _TL_("Christian & Gospel Music"),
  "Rock Music": _TL_("Rock Music"),
  "Metal (Music)": _TL_("Metal (Music)"),
  "Urban & Hip-Hop": _TL_("Urban & Hip-Hop"),
  "Rap & Hip-Hop": _TL_("Rap & Hip-Hop"),
  "Soul & R&B": _TL_("Soul & R&B"),
  "Sports Entertainment": _TL_("Sports Entertainment"),
  "Visual Art & Design": _TL_("Visual Art & Design"),
  "Painting": _TL_("Painting"),
  "Auto Parts & Accessories": _TL_("Auto Parts & Accessories"),
  "Auto Exterior Parts & Accessories": _TL_("Auto Exterior Parts & Accessories"),
  "Auto Interior Parts & Accessories": _TL_("Auto Interior Parts & Accessories"),
  "Automotive Electronic Components": _TL_("Automotive Electronic Components"),
  "Car Batteries": _TL_("Car Batteries"),
  "Car Brakes": _TL_("Car Brakes"),
  "Engine & Transmission": _TL_("Engine & Transmission"),
  "High Performance & Aftermarket Auto Parts": _TL_("High Performance & Aftermarket Auto Parts"),
  "Replacement Auto Parts": _TL_("Replacement Auto Parts"),
  "Wheels & Tires": _TL_("Wheels & Tires"),
  "Auto Repair & Maintenance": _TL_("Auto Repair & Maintenance"),
  "Brake Service & Repair": _TL_("Brake Service & Repair"),
  "Collision & Auto Body Repair": _TL_("Collision & Auto Body Repair"),
  "Glass Repair & Replacement": _TL_("Glass Repair & Replacement"),
  "Oil Changes": _TL_("Oil Changes"),
  "Transmission Repair": _TL_("Transmission Repair"),
  "Cars & Trucks": _TL_("Cars & Trucks"),
  "Motor Vehicles (New)": _TL_("Motor Vehicles (New)"),
  "Motor Vehicles (Used)": _TL_("Motor Vehicles (Used)"),
  "Motor Vehicles by Brand": _TL_("Motor Vehicles by Brand"),
  "Acura": _TL_("Acura"),
  "Alfa Romeo": _TL_("Alfa Romeo"),
  "Audi": _TL_("Audi"),
  "BMW": _TL_("BMW"),
  "Buick": _TL_("Buick"),
  "Cadillac": _TL_("Cadillac"),
  "Chevrolet": _TL_("Chevrolet"),
  "Chrysler": _TL_("Chrysler"),
  "Citroën": _TL_("Citroën"),
  "Dacia": _TL_("Dacia"),
  "Dodge": _TL_("Dodge"),
  "Fiat": _TL_("Fiat"),
  "Ford": _TL_("Ford"),
  "GMC": _TL_("GMC"),
  "Honda": _TL_("Honda"),
  "Hyundai": _TL_("Hyundai"),
  "Infiniti": _TL_("Infiniti"),
  "Isuzu": _TL_("Isuzu"),
  "Jaguar": _TL_("Jaguar"),
  "Jeep": _TL_("Jeep"),
  "Kia": _TL_("Kia"),
  "Land Rover": _TL_("Land Rover"),
  "Lexus": _TL_("Lexus"),
  "Lincoln": _TL_("Lincoln"),
  "Maserati": _TL_("Maserati"),
  "Mazda": _TL_("Mazda"),
  "Mercedes-Benz": _TL_("Mercedes-Benz"),
  "Mini": _TL_("Mini"),
  "Mitsubishi": _TL_("Mitsubishi"),
  "Nissan": _TL_("Nissan"),
  "Peugeot": _TL_("Peugeot"),
  "Porsche": _TL_("Porsche"),
  "Ram Trucks": _TL_("Ram Trucks"),
  "Renault": _TL_("Renault"),
  "SEAT": _TL_("SEAT"),
  "Skoda": _TL_("Skoda"),
  "Smart": _TL_("Smart"),
  "Subaru": _TL_("Subaru"),
  "Suzuki": _TL_("Suzuki"),
  "Toyota": _TL_("Toyota"),
  "Vauxhall-Opel": _TL_("Vauxhall-Opel"),
  "Volkswagen": _TL_("Volkswagen"),
  "Volvo": _TL_("Volvo"),
  "Motor Vehicles by Type": _TL_("Motor Vehicles by Type"),
  "Classic Vehicles": _TL_("Classic Vehicles"),
  "Compact Cars": _TL_("Compact Cars"),
  "Compact Cars (New)": _TL_("Compact Cars (New)"),
  "Compact Cars (Used)": _TL_("Compact Cars (Used)"),
  "Convertibles": _TL_("Convertibles"),
  "Convertibles (New)": _TL_("Convertibles (New)"),
  "Convertibles (Used)": _TL_("Convertibles (Used)"),
  "Coupes": _TL_("Coupes"),
  "Coupes (New)": _TL_("Coupes (New)"),
  "Coupes (Used)": _TL_("Coupes (Used)"),
  "Crossovers": _TL_("Crossovers"),
  "Crossovers (New)": _TL_("Crossovers (New)"),
  "Crossovers (Used)": _TL_("Crossovers (Used)"),
  "Diesel Vehicles": _TL_("Diesel Vehicles"),
  "Hatchbacks": _TL_("Hatchbacks"),
  "Hatchbacks (New)": _TL_("Hatchbacks (New)"),
  "Hatchbacks (Used)": _TL_("Hatchbacks (Used)"),
  "Hybrid & Alternative Vehicles": _TL_("Hybrid & Alternative Vehicles"),
  "Hybrid & Alternative Vehicles (New)": _TL_("Hybrid & Alternative Vehicles (New)"),
  "Hybrid & Alternative Vehicles (Used)": _TL_("Hybrid & Alternative Vehicles (Used)"),
  "Luxury Vehicles": _TL_("Luxury Vehicles"),
  "Luxury Vehicles (New)": _TL_("Luxury Vehicles (New)"),
  "Luxury Vehicles (Used)": _TL_("Luxury Vehicles (Used)"),
  "Microcars & Subcompacts": _TL_("Microcars & Subcompacts"),
  "Microcars & Subcompacts (New)": _TL_("Microcars & Subcompacts (New)"),
  "Microcars & Subcompacts (Used)": _TL_("Microcars & Subcompacts (Used)"),
  "Motorcycles": _TL_("Motorcycles"),
  "Motorcycles (New)": _TL_("Motorcycles (New)"),
  "Motorcycles (Used)": _TL_("Motorcycles (Used)"),
  "Off-Road Vehicles": _TL_("Off-Road Vehicles"),
  "Off-Road Vehicles (New)": _TL_("Off-Road Vehicles (New)"),
  "Off-Road Vehicles (Used)": _TL_("Off-Road Vehicles (Used)"),
  "Pickup Trucks": _TL_("Pickup Trucks"),
  "Pickup Trucks (New)": _TL_("Pickup Trucks (New)"),
  "Pickup Trucks (Used)": _TL_("Pickup Trucks (Used)"),
  "Scooters & Mopeds": _TL_("Scooters & Mopeds"),
  "Scooters & Mopeds (New)": _TL_("Scooters & Mopeds (New)"),
  "Scooters & Mopeds (Used)": _TL_("Scooters & Mopeds (Used)"),
  "Sedans": _TL_("Sedans"),
  "Sedans (New)": _TL_("Sedans (New)"),
  "Sports Cars": _TL_("Sports Cars"),
  "Sports Cars (New)": _TL_("Sports Cars (New)"),
  "Sports Cars (Used)": _TL_("Sports Cars (Used)"),
  "Station Wagons": _TL_("Station Wagons"),
  "Station Wagons (New)": _TL_("Station Wagons (New)"),
  "Station Wagons (Used)": _TL_("Station Wagons (Used)"),
  "SUVs": _TL_("SUVs"),
  "SUVs (New)": _TL_("SUVs (New)"),
  "Vans & Minivans": _TL_("Vans & Minivans"),
  "Vans & Minivans (New)": _TL_("Vans & Minivans (New)"),
  "Vans & Minivans (Used)": _TL_("Vans & Minivans (Used)"),
  "Vehicle Parts & Accessories": _TL_("Vehicle Parts & Accessories"),
  "Car Parts & Accessories": _TL_("Car Parts & Accessories"),
  "Vehicles (Other)": _TL_("Vehicles (Other)"),
  "Bicycles & Accessories": _TL_("Bicycles & Accessories"),
  "Boats & Watercraft": _TL_("Boats & Watercraft"),
  "Campers & RVs": _TL_("Campers & RVs"),
  "Commercial Vehicles": _TL_("Commercial Vehicles"),
  "Baby & Children's Products": _TL_("Baby & Children's Products"),
  "Baby & Children's Apparel": _TL_("Baby & Children's Apparel"),
  "Baby & Toddler Apparel": _TL_("Baby & Toddler Apparel"),
  "Children's Apparel": _TL_("Children's Apparel"),
  "Child Car Seats": _TL_("Child Car Seats"),
  "Childcare & Education": _TL_("Childcare & Education"),
  "Childcare": _TL_("Childcare"),
  "Early Childhood Education": _TL_("Early Childhood Education"),
  "Diapers & Baby Hygiene Products": _TL_("Diapers & Baby Hygiene Products"),
  "Infant & Toddler Feeding": _TL_("Infant & Toddler Feeding"),
  "Infant Feeding Supplies": _TL_("Infant Feeding Supplies"),
  "Toddler Meals": _TL_("Toddler Meals"),
  "Strollers & Baby Carriages": _TL_("Strollers & Baby Carriages"),
  "Toys & Games": _TL_("Toys & Games"),
  "Beauty & Personal Care": _TL_("Beauty & Personal Care"),
  "Body Art": _TL_("Body Art"),
  "Fashion & Style": _TL_("Fashion & Style"),
  "Fashion Designers & Collections": _TL_("Fashion Designers & Collections"),
  "Beauty Products & Services": _TL_("Beauty Products & Services"),
  "Bath & Body Products": _TL_("Bath & Body Products"),
  "Hair Care Products": _TL_("Hair Care Products"),
  "Makeup & Cosmetics": _TL_("Makeup & Cosmetics"),
  "Eye Makeup": _TL_("Eye Makeup"),
  "Face Makeup": _TL_("Face Makeup"),
  "Lip Makeup": _TL_("Lip Makeup"),
  "Nail Care Products": _TL_("Nail Care Products"),
  "Skin Care Products": _TL_("Skin Care Products"),
  "Anti-Aging Skin Care Products": _TL_("Anti-Aging Skin Care Products"),
  "Face Lotions & Moisturizers": _TL_("Face Lotions & Moisturizers"),
  "Facial Cleansers & Makeup Removers": _TL_("Facial Cleansers & Makeup Removers"),
  "Spas & Beauty Services": _TL_("Spas & Beauty Services"),
  "Manicures & Pedicures": _TL_("Manicures & Pedicures"),
  "Tanning & Sun Care Products": _TL_("Tanning & Sun Care Products"),
  "Business & Industrial Products": _TL_("Business & Industrial Products"),
  "Food Service Equipment": _TL_("Food Service Equipment"),
  "Industrial Goods & Manufacturing": _TL_("Industrial Goods & Manufacturing"),
  "Material Handling Equipment": _TL_("Material Handling Equipment"),
  "Signage": _TL_("Signage"),
  "Work Safety Protective Gear": _TL_("Work Safety Protective Gear"),
  "Business & Industrial": _TL_("Business & Industrial"),
  "Aerospace & Defense": _TL_("Aerospace & Defense"),
  "Design & Engineering": _TL_("Design & Engineering"),
  "Graphic Design": _TL_("Graphic Design"),
  "Scientific Equipment & Services": _TL_("Scientific Equipment & Services"),
  "Business Services": _TL_("Business Services"),
  "Advertising & Marketing Services": _TL_("Advertising & Marketing Services"),
  "Email Marketing Services": _TL_("Email Marketing Services"),
  "SEO & SEM Services": _TL_("SEO & SEM Services"),
  "Building Construction & Maintenance": _TL_("Building Construction & Maintenance"),
  "Building Materials & Supplies": _TL_("Building Materials & Supplies"),
  "Business Financial Services": _TL_("Business Financial Services"),
  "Business Printing & Document Services": _TL_("Business Printing & Document Services"),
  "Business Technology": _TL_("Business Technology"),
  "Business & Productivity Software": _TL_("Business & Productivity Software"),
  "E-Commerce & Retail Software": _TL_("E-Commerce & Retail Software"),
  "Enterprise Software": _TL_("Enterprise Software"),
  "Collaboration & Conferencing Tools": _TL_("Collaboration & Conferencing Tools"),
  "CRM Solutions": _TL_("CRM Solutions"),
  "ERP Solutions": _TL_("ERP Solutions"),
  "Helpdesk & Customer Support Solutions": _TL_("Helpdesk & Customer Support Solutions"),
  "Network Systems & Services": _TL_("Network Systems & Services"),
  "Hosted Data & Cloud Storage": _TL_("Hosted Data & Cloud Storage"),
  "Network & Enterprise Security": _TL_("Network & Enterprise Security"),
  "Network Equipment & Virtualization": _TL_("Network Equipment & Virtualization"),
  "Network Management": _TL_("Network Management"),
  "Web Services": _TL_("Web Services"),
  "Domain Registration": _TL_("Domain Registration"),
  "Web Design & Development": _TL_("Web Design & Development"),
  "Web Hosting": _TL_("Web Hosting"),
  "Corporate Event Planning": _TL_("Corporate Event Planning"),
  "Office Supplies": _TL_("Office Supplies"),
  "Business Cards, Stationery & Forms": _TL_("Business Cards, Stationery & Forms"),
  "Office Furniture": _TL_("Office Furniture"),
  "Payment Processing & Merchant Services": _TL_("Payment Processing & Merchant Services"),
  "Payroll Services": _TL_("Payroll Services"),
  "Physical Security & Access Control": _TL_("Physical Security & Access Control"),
  "Staffing & Recruitment Services": _TL_("Staffing & Recruitment Services"),
  "Company Size": _TL_("Company Size"),
  "1-10 Employees": _TL_("1-10 Employees"),
  "Company size": _TL_("Company size"),
  "1-10 employees": _TL_("1-10 employees"),
  "10,001+ Employees": _TL_("10,001+ Employees"),
  "10,001+ employees": _TL_("10,001+ employees"),
  "1001-5000 Employees": _TL_("1001-5000 Employees"),
  "1001-5000 employees": _TL_("1001-5000 employees"),
  "11-50 Employees": _TL_("11-50 Employees"),
  "11-50 employees": _TL_("11-50 employees"),
  "201-500 Employees": _TL_("201-500 Employees"),
  "201-500 employees": _TL_("201-500 employees"),
  "5001-10,000 Employees": _TL_("5001-10,000 Employees"),
  "5001-10,000 employees": _TL_("5001-10,000 employees"),
  "501-1000 Employees": _TL_("501-1000 Employees"),
  "501-1000 employees": _TL_("501-1000 employees"),
  "51-200 Employees": _TL_("51-200 Employees"),
  "51-200 employees": _TL_("51-200 employees"),
  "Self-Employed": _TL_("Self-Employed"),
  "Self-employed": _TL_("Self-employed"),
  "Computers & Consumer Electronics": _TL_("Computers & Consumer Electronics"),
  "Computer Components": _TL_("Computer Components"),
  "Computer Processors": _TL_("Computer Processors"),
  "Computer Memory & Storage Devices": _TL_("Computer Memory & Storage Devices"),
  "External Hard Drives": _TL_("External Hard Drives"),
  "Computer Monitors & Projectors": _TL_("Computer Monitors & Projectors"),
  "Electronic Projectors": _TL_("Electronic Projectors"),
  "Computer Servers": _TL_("Computer Servers"),
  "Freeware & Shareware": _TL_("Freeware & Shareware"),
  "Internet Software & Web Goodies": _TL_("Internet Software & Web Goodies"),
  "GPS & Navigation": _TL_("GPS & Navigation"),
  "GPS Devices": _TL_("GPS Devices"),
  "Portable Media Devices": _TL_("Portable Media Devices"),
  "Digital Book Readers": _TL_("Digital Book Readers"),
  "Computers & Peripherals": _TL_("Computers & Peripherals"),
  "Computer Accessories & Components": _TL_("Computer Accessories & Components"),
  "Computer Monitors": _TL_("Computer Monitors"),
  "Memory & Storage": _TL_("Memory & Storage"),
  "Desktop Computers": _TL_("Desktop Computers"),
  "Laptops & Notebooks": _TL_("Laptops & Notebooks"),
  "Tablets & Ultraportable Devices": _TL_("Tablets & Ultraportable Devices"),
  "Printers, Scanners & Faxes": _TL_("Printers, Scanners & Faxes"),
  "Printers": _TL_("Printers"),
  "Audio": _TL_("Audio"),
  "Car Audio": _TL_("Car Audio"),
  "Headphones & Headsets": _TL_("Headphones & Headsets"),
  "MP3 Players": _TL_("MP3 Players"),
  "Pro Musician & DJ Equipment": _TL_("Pro Musician & DJ Equipment"),
  "Speakers": _TL_("Speakers"),
  "Stereo Systems": _TL_("Stereo Systems"),
  "Batteries": _TL_("Batteries"),
  "Camcorders": _TL_("Camcorders"),
  "Cameras": _TL_("Cameras"),
  "Camera Lenses": _TL_("Camera Lenses"),
  "Digital SLRs": _TL_("Digital SLRs"),
  "Point & Shoots": _TL_("Point & Shoots"),
  "DVD & Blu-Ray Players": _TL_("DVD & Blu-Ray Players"),
  "Game Consoles": _TL_("Game Consoles"),
  "Nintendo Consoles": _TL_("Nintendo Consoles"),
  "Nintendo (Wii)": _TL_("Nintendo (Wii)"),
  "Sony PlayStation": _TL_("Sony PlayStation"),
  "Xbox": _TL_("Xbox"),
  "Home Theater Systems": _TL_("Home Theater Systems"),
  "Mobile Phones": _TL_("Mobile Phones"),
  "Android Phones": _TL_("Android Phones"),
  "iOS Phones": _TL_("iOS Phones"),
  "Power Adapters & Chargers": _TL_("Power Adapters & Chargers"),
  "Televisions": _TL_("Televisions"),
  "HDTVs": _TL_("HDTVs"),
  "LCD TVs": _TL_("LCD TVs"),
  "Plasma TVs": _TL_("Plasma TVs"),
  "Dating Services": _TL_("Dating Services"),
  "Dining & Nightlife": _TL_("Dining & Nightlife"),
  "Nightclubs, Bars & Music Clubs": _TL_("Nightclubs, Bars & Music Clubs"),
  "Dine-In Restaurants": _TL_("Dine-In Restaurants"),
  "Fast Food Restaurants": _TL_("Fast Food Restaurants"),
  "Education": _TL_("Education"),
  "Foreign Language Study": _TL_("Foreign Language Study"),
  "Post-Secondary Education": _TL_("Post-Secondary Education"),
  "Arts & Design Education": _TL_("Arts & Design Education"),
  "Business Education": _TL_("Business Education"),
  "Cosmetology Education & Training": _TL_("Cosmetology Education & Training"),
  "Health Care Education": _TL_("Health Care Education"),
  "Nursing Education": _TL_("Nursing Education"),
  "Technology Education": _TL_("Technology Education"),
  "Primary & Secondary Schools (K-12)": _TL_("Primary & Secondary Schools (K-12)"),
  "Study Abroad Programs": _TL_("Study Abroad Programs"),
  "Test Preparation & Tutoring": _TL_("Test Preparation & Tutoring"),
  "Employment": _TL_("Employment"),
  "Accounting & Finance Jobs": _TL_("Accounting & Finance Jobs"),
  "Career Consulting Services": _TL_("Career Consulting Services"),
  "Clerical & Administrative Jobs": _TL_("Clerical & Administrative Jobs"),
  "Education Jobs": _TL_("Education Jobs"),
  "Executive & Management Jobs": _TL_("Executive & Management Jobs"),
  "Government & Public Sector Jobs": _TL_("Government & Public Sector Jobs"),
  "Health & Medical Jobs": _TL_("Health & Medical Jobs"),
  "Internships": _TL_("Internships"),
  "IT & Technical Jobs": _TL_("IT & Technical Jobs"),
  "Jobs & Careers": _TL_("Jobs & Careers"),
  "Legal Jobs": _TL_("Legal Jobs"),
  "Resumes & Portfolios": _TL_("Resumes & Portfolios"),
  "Sales & Marketing Jobs": _TL_("Sales & Marketing Jobs"),
  "Temporary & Seasonal Jobs": _TL_("Temporary & Seasonal Jobs"),
  "Event Tickets": _TL_("Event Tickets"),
  "Concert & Music Festival Tickets": _TL_("Concert & Music Festival Tickets"),
  "Performing Arts Tickets": _TL_("Performing Arts Tickets"),
  "Broadway & Theater Tickets": _TL_("Broadway & Theater Tickets"),
  "Sports Tickets": _TL_("Sports Tickets"),
  "Family & Community": _TL_("Family & Community"),
  "Baby, Parenting & Family": _TL_("Baby, Parenting & Family"),
  "Parenting & Family": _TL_("Parenting & Family"),
  "Community Service & Social Organizations": _TL_("Community Service & Social Organizations"),
  "Community Outreach": _TL_("Community Outreach"),
  "Environmentalism": _TL_("Environmentalism"),
  "Social Issues & Advocacy": _TL_("Social Issues & Advocacy"),
  "Environmental Activism": _TL_("Environmental Activism"),
  "Volunteer Opportunities": _TL_("Volunteer Opportunities"),
  "Faith & Belief": _TL_("Faith & Belief"),
  "Meditation": _TL_("Meditation"),
  "Romance & Relationships": _TL_("Romance & Relationships"),
  "Dating & Marriage Matching": _TL_("Dating & Marriage Matching"),
  "Banking": _TL_("Banking"),
  "Bank Accounts": _TL_("Bank Accounts"),
  "Private Banking": _TL_("Private Banking"),
  "Business Finance": _TL_("Business Finance"),
  "Investment Banking": _TL_("Investment Banking"),
  "Mutual Funds": _TL_("Mutual Funds"),
  "Securities": _TL_("Securities"),
  "Stocks": _TL_("Stocks"),
  "Financial Services": _TL_("Financial Services"),
  "Accounting & Auditing": _TL_("Accounting & Auditing"),
  "Banking Services": _TL_("Banking Services"),
  "Debit & Checking Services": _TL_("Debit & Checking Services"),
  "Savings Accounts": _TL_("Savings Accounts"),
  "Credit & Lending": _TL_("Credit & Lending"),
  "Auto Loans": _TL_("Auto Loans"),
  "Business Loans": _TL_("Business Loans"),
  "Credit Reports & Monitoring Services": _TL_("Credit Reports & Monitoring Services"),
  "Mortgage": _TL_("Mortgage"),
  "Home Equity Loans": _TL_("Home Equity Loans"),
  "Home Purchase Loans": _TL_("Home Purchase Loans"),
  "Mortgage Refinancing": _TL_("Mortgage Refinancing"),
  "Personal Loans": _TL_("Personal Loans"),
  "Student Loans": _TL_("Student Loans"),
  "Financial Planning": _TL_("Financial Planning"),
  "Estate Planning": _TL_("Estate Planning"),
  "Retirement Planning": _TL_("Retirement Planning"),
  "Auto Insurance": _TL_("Auto Insurance"),
  "Home Insurance": _TL_("Home Insurance"),
  "Life Insurance": _TL_("Life Insurance"),
  "Travel Insurance": _TL_("Travel Insurance"),
  "Investment Services": _TL_("Investment Services"),
  "Tax Services": _TL_("Tax Services"),
  "Food & Groceries": _TL_("Food & Groceries"),
  "Beverages": _TL_("Beverages"),
  "Alcoholic Beverages": _TL_("Alcoholic Beverages"),
  "Beer": _TL_("Beer"),
  "Liquor": _TL_("Liquor"),
  "Wine": _TL_("Wine"),
  "Non-Alcoholic Beverages": _TL_("Non-Alcoholic Beverages"),
  "Coffee": _TL_("Coffee"),
  "Energy Drinks": _TL_("Energy Drinks"),
  "Juice": _TL_("Juice"),
  "Soft Drinks": _TL_("Soft Drinks"),
  "Tea": _TL_("Tea"),
  "Desserts": _TL_("Desserts"),
  "Fish & Seafood": _TL_("Fish & Seafood"),
  "Organic & Natural Foods": _TL_("Organic & Natural Foods"),
  "Baked Goods": _TL_("Baked Goods"),
  "Candy & Chocolate": _TL_("Candy & Chocolate"),
  "Condiments & Sauces": _TL_("Condiments & Sauces"),
  "Cooking & Baking Ingredients": _TL_("Cooking & Baking Ingredients"),
  "Grocery Delivery": _TL_("Grocery Delivery"),
  "Restaurant Delivery & Takeout": _TL_("Restaurant Delivery & Takeout"),
  "Gifts & Occasions": _TL_("Gifts & Occasions"),
  "Cards & Greetings": _TL_("Cards & Greetings"),
  "Flowers": _TL_("Flowers"),
  "Gift Baskets": _TL_("Gift Baskets"),
  "Holiday & Seasonal Items": _TL_("Holiday & Seasonal Items"),
  "Christmas Items & Decor": _TL_("Christmas Items & Decor"),
  "Halloween Items & Decor": _TL_("Halloween Items & Decor"),
  "Valentine's Day Items & Decor": _TL_("Valentine's Day Items & Decor"),
  "Party Supplies & Planning": _TL_("Party Supplies & Planning"),
  "Event Planning Services": _TL_("Event Planning Services"),
  "Party Supplies": _TL_("Party Supplies"),
  "Personalized Gifts": _TL_("Personalized Gifts"),
  "Photo & Video Services": _TL_("Photo & Video Services"),
  "Event Photographers & Studios": _TL_("Event Photographers & Studios"),
  "Photo Printing Services": _TL_("Photo Printing Services"),
  "Wedding Planning": _TL_("Wedding Planning"),
  "Hospice & Home Nursing Care": _TL_("Hospice & Home Nursing Care"),
  "Hobbies & Leisure": _TL_("Hobbies & Leisure"),
  "Camping & Outdoor Recreation": _TL_("Camping & Outdoor Recreation"),
  "Cooking": _TL_("Cooking"),
  "Cuisines": _TL_("Cuisines"),
  "Asian Cuisine": _TL_("Asian Cuisine"),
  "Chinese Cuisine": _TL_("Chinese Cuisine"),
  "French Cuisine": _TL_("French Cuisine"),
  "Indian Cuisine": _TL_("Indian Cuisine"),
  "Latin American Cuisine": _TL_("Latin American Cuisine"),
  "Mexican Cuisine": _TL_("Mexican Cuisine"),
  "Mediterranean Cuisine": _TL_("Mediterranean Cuisine"),
  "Spanish Cuisine": _TL_("Spanish Cuisine"),
  "Vegetarian Cuisine": _TL_("Vegetarian Cuisine"),
  "Vegetarian & Vegan Foods": _TL_("Vegetarian & Vegan Foods"),
  "Pets & Animals": _TL_("Pets & Animals"),
  "Pet Food & Supplies": _TL_("Pet Food & Supplies"),
  "Pet Food & Treats": _TL_("Pet Food & Treats"),
  "Photo & Video": _TL_("Photo & Video"),
  "Photographic & Digital Arts": _TL_("Photographic & Digital Arts"),
  "Board Games": _TL_("Board Games"),
  "Online Games & Puzzles": _TL_("Online Games & Puzzles"),
  "Massive Multiplayer Online Games": _TL_("Massive Multiplayer Online Games"),
  "Puzzles & Brainteasers": _TL_("Puzzles & Brainteasers"),
  "Roleplaying Games": _TL_("Roleplaying Games"),
  "Strategy Games": _TL_("Strategy Games"),
  "Pool & Billiards": _TL_("Pool & Billiards"),
  "Video Games, Consoles & Accessories": _TL_("Video Games, Consoles & Accessories"),
  "Computer & Video Games": _TL_("Computer & Video Games"),
  "Driving & Racing Games": _TL_("Driving & Racing Games"),
  "Shooter Games": _TL_("Shooter Games"),
  "Simulation Games": _TL_("Simulation Games"),
  "Sports Games": _TL_("Sports Games"),
  "Children's Dolls, Dress-Up Toys & Costumes": _TL_("Children's Dolls, Dress-Up Toys & Costumes"),
  "Online Doll Dress-Up & Girl Games": _TL_("Online Doll Dress-Up & Girl Games"),
  "Cookware & Bakeware": _TL_("Cookware & Bakeware"),
  "Architectural Services": _TL_("Architectural Services"),
  "Carpet Installation": _TL_("Carpet Installation"),
  "Door & Window Installation": _TL_("Door & Window Installation"),
  "Electrician Services": _TL_("Electrician Services"),
  "Flooring Services": _TL_("Flooring Services"),
  "General Contracting & Remodeling Services": _TL_("General Contracting & Remodeling Services"),
  "Home Cleaning Services": _TL_("Home Cleaning Services"),
  "Interior Design & Decorating Services": _TL_("Interior Design & Decorating Services"),
  "Landscape Design": _TL_("Landscape Design"),
  "Lawn & Garden Maintenance": _TL_("Lawn & Garden Maintenance"),
  "Locksmith Services": _TL_("Locksmith Services"),
  "Painting Services": _TL_("Painting Services"),
  "Pest Control Services": _TL_("Pest Control Services"),
  "Pest Control": _TL_("Pest Control"),
  "Plumbing Services": _TL_("Plumbing Services"),
  "Roofing Services": _TL_("Roofing Services"),
  "Yard Garden & Patio": _TL_("Yard Garden & Patio"),
  "Yard Garden and Patio": _TL_("Yard Garden and Patio"),
  "Yard & Garden Equipment & Supplies": _TL_("Yard & Garden Equipment & Supplies"),
  "Home Appliances": _TL_("Home Appliances"),
  "Climate Control Appliances": _TL_("Climate Control Appliances"),
  "Air Conditioners": _TL_("Air Conditioners"),
  "Fans": _TL_("Fans"),
  "Cooking Ranges & Stoves": _TL_("Cooking Ranges & Stoves"),
  "Dishwashers": _TL_("Dishwashers"),
  "Kitchen Appliance Accessories": _TL_("Kitchen Appliance Accessories"),
  "Coffee Maker & Espresso Machine Accessories": _TL_("Coffee Maker & Espresso Machine Accessories"),
  "Mixer & Blender Accessories": _TL_("Mixer & Blender Accessories"),
  "Refrigerator Accessories": _TL_("Refrigerator Accessories"),
  "Microwaves": _TL_("Microwaves"),
  "Refrigerators": _TL_("Refrigerators"),
  "Small Appliances": _TL_("Small Appliances"),
  "Coffee & Espresso Makers": _TL_("Coffee & Espresso Makers"),
  "Juicers & Blenders": _TL_("Juicers & Blenders"),
  "Mixers": _TL_("Mixers"),
  "Vacuums": _TL_("Vacuums"),
  "Washers & Dryers": _TL_("Washers & Dryers"),
  "Home Decor": _TL_("Home Decor"),
  "Bedding": _TL_("Bedding"),
  "Curtains & Window Treatments": _TL_("Curtains & Window Treatments"),
  "Curtains & Drapes": _TL_("Curtains & Drapes"),
  "Window Blinds & Shades": _TL_("Window Blinds & Shades"),
  "Fine Art": _TL_("Fine Art"),
  "Fireplaces": _TL_("Fireplaces"),
  "Lights & Fixtures": _TL_("Lights & Fixtures"),
  "Ceiling Light Fixtures": _TL_("Ceiling Light Fixtures"),
  "Wall Light Fixtures": _TL_("Wall Light Fixtures"),
  "Linens": _TL_("Linens"),
  "Rugs & Carpets": _TL_("Rugs & Carpets"),
  "Home Furnishings": _TL_("Home Furnishings"),
  "Antiques & Collectibles": _TL_("Antiques & Collectibles"),
  "Bedroom": _TL_("Bedroom"),
  "Beds & Bed Frames": _TL_("Beds & Bed Frames"),
  "Mattresses": _TL_("Mattresses"),
  "Home Office": _TL_("Home Office"),
  "Desks": _TL_("Desks"),
  "Office Chairs": _TL_("Office Chairs"),
  "Home Storage & Shelving": _TL_("Home Storage & Shelving"),
  "Kitchen & Dining Room": _TL_("Kitchen & Dining Room"),
  "Kitchen & Dining Room Tables": _TL_("Kitchen & Dining Room Tables"),
  "Stools": _TL_("Stools"),
  "Living Room": _TL_("Living Room"),
  "Accent Tables": _TL_("Accent Tables"),
  "Sofas": _TL_("Sofas"),
  "Nursery": _TL_("Nursery"),
  "Home Improvement": _TL_("Home Improvement"),
  "Flooring": _TL_("Flooring"),
  "Kitchen & Bathroom Cabinets": _TL_("Kitchen & Bathroom Cabinets"),
  "Kitchen & Bathroom Counters": _TL_("Kitchen & Bathroom Counters"),
  "Paint": _TL_("Paint"),
  "Plumbing Fixture Hardware & Parts": _TL_("Plumbing Fixture Hardware & Parts"),
  "Plumbing Fixtures": _TL_("Plumbing Fixtures"),
  "Power & Electrical Supplies": _TL_("Power & Electrical Supplies"),
  "Tools": _TL_("Tools"),
  "Measuring Tools & Sensors": _TL_("Measuring Tools & Sensors"),
  "Home Security": _TL_("Home Security"),
  "Household Supplies": _TL_("Household Supplies"),
  "Household Cleaning Supplies": _TL_("Household Cleaning Supplies"),
  "Pest Control Supplies": _TL_("Pest Control Supplies"),
  "Kitchen & Dining": _TL_("Kitchen & Dining"),
  "Kitchen Tools & Utensils": _TL_("Kitchen Tools & Utensils"),
  "Outdoor Items": _TL_("Outdoor Items"),
  "BBQ & Grill Accessories": _TL_("BBQ & Grill Accessories"),
  "BBQs & Grills": _TL_("BBQs & Grills"),
  "Garden & Outdoor Furniture": _TL_("Garden & Outdoor Furniture"),
  "Outdoor Furniture Sets": _TL_("Outdoor Furniture Sets"),
  "Garden Sheds & Outdoor Structures": _TL_("Garden Sheds & Outdoor Structures"),
  "Lawn Care & Gardening Supplies": _TL_("Lawn Care & Gardening Supplies"),
  "Lawn Mowers": _TL_("Lawn Mowers"),
  "Pools & Spas": _TL_("Pools & Spas"),
  "Pet Supplies": _TL_("Pet Supplies"),
  "Cat Food & Supplies": _TL_("Cat Food & Supplies"),
  "Dog Food & Supplies": _TL_("Dog Food & Supplies"),
  "Tableware": _TL_("Tableware"),
  "Internet & Telecom": _TL_("Internet & Telecom"),
  "Social Networks & Online Communities": _TL_("Social Networks & Online Communities"),
  "Mobile Social Networks": _TL_("Mobile Social Networks"),
  "3d Artist": _TL_("3d Artist"),
  "3d Designer": _TL_("3d Designer"),
  "Accountant": _TL_("Accountant"),
  "Accounts Payable Clerk": _TL_("Accounts Payable Clerk"),
  "Accounts Receivable Clerk": _TL_("Accounts Receivable Clerk"),
  "Actuary": _TL_("Actuary"),
  "Administrative Employee": _TL_("Administrative Employee"),
  "Advertising Specialist": _TL_("Advertising Specialist"),
  "Agriculturist": _TL_("Agriculturist"),
  "Alternative Medicine Practitioner": _TL_("Alternative Medicine Practitioner"),
  "Animator": _TL_("Animator"),
  "Archaeology and History Researcher": _TL_("Archaeology and History Researcher"),
  "Architect": _TL_("Architect"),
  "Art Curator": _TL_("Art Curator"),
  "Arts Professional": _TL_("Arts Professional"),
  "Asset Manager": _TL_("Asset Manager"),
  "Audio-Visual Specialist": _TL_("Audio-Visual Specialist"),
  "Auditor": _TL_("Auditor"),
  "Author": _TL_("Author"),
  "Automotive Salesperson": _TL_("Automotive Salesperson"),
  "Avionics and Flight Engineer": _TL_("Avionics and Flight Engineer"),
  "Banking Consultant": _TL_("Banking Consultant"),
  "Banking Sales Consultant": _TL_("Banking Sales Consultant"),
  "Benefits Specialist": _TL_("Benefits Specialist"),
  "Bioinformatician": _TL_("Bioinformatician"),
  "Branch Bank Employee": _TL_("Branch Bank Employee"),
  "Business Analyst": _TL_("Business Analyst"),
  "Business Development Specialist": _TL_("Business Development Specialist"),
  "Business Intelligence Consultant": _TL_("Business Intelligence Consultant"),
  "Business Intern": _TL_("Business Intern"),
  "business intern": _TL_("business intern"),
  "Business Strategist": _TL_("Business Strategist"),
  "Buyer": _TL_("Buyer"),
  "Buyer Sourcing": _TL_("Buyer Sourcing"),
  "Camp Counselor": _TL_("Camp Counselor"),
  "Campaign Coordinator": _TL_("Campaign Coordinator"),
  "Capital Markets Specialist": _TL_("Capital Markets Specialist"),
  "Career Counselor": _TL_("Career Counselor"),
  "Caregiver": _TL_("Caregiver"),
  "Category Manager": _TL_("Category Manager"),
  "Chemical Process Engineer": _TL_("Chemical Process Engineer"),
  "Chemist": _TL_("Chemist"),
  "Chief Information Officer": _TL_("Chief Information Officer"),
  "Chief of Department": _TL_("Chief of Department"),
  "chief of department": _TL_("chief of department"),
  "Chief Technology Officer": _TL_("Chief Technology Officer"),
  "Civil Engineer": _TL_("Civil Engineer"),
  "Claims Specialist": _TL_("Claims Specialist"),
  "Clinical Research Specialist": _TL_("Clinical Research Specialist"),
  "Commercial Banker": _TL_("Commercial Banker"),
  "Commercial Loan Officer": _TL_("Commercial Loan Officer"),
  "Commercial Real Estate Specialist": _TL_("Commercial Real Estate Specialist"),
  "Community Development Specialist": _TL_("Community Development Specialist"),
  "Compensation Specialist": _TL_("Compensation Specialist"),
  "Compliance Specialist": _TL_("Compliance Specialist"),
  "Computer Aided Designer": _TL_("Computer Aided Designer"),
  "Construction Engineer": _TL_("Construction Engineer"),
  "Construction Project Planner": _TL_("Construction Project Planner"),
  "Contract Administrator": _TL_("Contract Administrator"),
  "Contract Worker": _TL_("Contract Worker"),
  "contract worker": _TL_("contract worker"),
  "Control Systems Engineer": _TL_("Control Systems Engineer"),
  "Corporate Board Member": _TL_("Corporate Board Member"),
  "Corporate Finance Specialist": _TL_("Corporate Finance Specialist"),
  "Corporate Merger Specialist": _TL_("Corporate Merger Specialist"),
  "Corporate Tax Specialist": _TL_("Corporate Tax Specialist"),
  "Corporate Trainer": _TL_("Corporate Trainer"),
  "Creative Designer": _TL_("Creative Designer"),
  "Credit Analyst": _TL_("Credit Analyst"),
  "Customer Service Specialist": _TL_("Customer Service Specialist"),
  "Data Analyst": _TL_("Data Analyst"),
  "Data Entry Clerk": _TL_("Data Entry Clerk"),
  "Database Developer": _TL_("Database Developer"),
  "Database Marketing Specialist": _TL_("Database Marketing Specialist"),
  "Datacenter Manager": _TL_("Datacenter Manager"),
  "Dentist": _TL_("Dentist"),
  "Dietitian": _TL_("Dietitian"),
  "Document Controller": _TL_("Document Controller"),
  "E-Commerce Specialist": _TL_("E-Commerce Specialist"),
  "Economist": _TL_("Economist"),
  "Education Administrator": _TL_("Education Administrator"),
  "Electrical Engineer": _TL_("Electrical Engineer"),
  "Embedded Software Engineer": _TL_("Embedded Software Engineer"),
  "Engineer": _TL_("Engineer"),
  "Entertainment Administrator": _TL_("Entertainment Administrator"),
  "Environmental Specialist": _TL_("Environmental Specialist"),
  "Equity Analyst": _TL_("Equity Analyst"),
  "Equity Research Analyst": _TL_("Equity Research Analyst"),
  "ERP Consultant": _TL_("ERP Consultant"),
  "Event Planner": _TL_("Event Planner"),
  "Executive Director": _TL_("Executive Director"),
  "Export Sales Specialist": _TL_("Export Sales Specialist"),
  "Facilities Manager": _TL_("Facilities Manager"),
  "Factory Worker": _TL_("Factory Worker"),
  "Fashion Designer": _TL_("Fashion Designer"),
  "Federal Salesperson": _TL_("Federal Salesperson"),
  "Finance Specialist": _TL_("Finance Specialist"),
  "Financial Advisor": _TL_("Financial Advisor"),
  "Financial Aid Specialist": _TL_("Financial Aid Specialist"),
  "Financial Research Analyst": _TL_("Financial Research Analyst"),
  "Flight Crew": _TL_("Flight Crew"),
  "Food Service Professional": _TL_("Food Service Professional"),
  "Food Technologist": _TL_("Food Technologist"),
  "Founder": _TL_("Founder"),
  "Fraud Analyst": _TL_("Fraud Analyst"),
  "Fund Accountant": _TL_("Fund Accountant"),
  "Fundraiser": _TL_("Fundraiser"),
  "Game Designer": _TL_("Game Designer"),
  "Geologist": _TL_("Geologist"),
  "GIS Specialist": _TL_("GIS Specialist"),
  "Global Financial Representative": _TL_("Global Financial Representative"),
  "global financial representative": _TL_("global financial representative"),
  "Government Policy Specialist": _TL_("Government Policy Specialist"),
  "Graphic Designer": _TL_("Graphic Designer"),
  "graphic designer": _TL_("graphic designer"),
  "Hardware Engineer": _TL_("Hardware Engineer"),
  "Health Specialist": _TL_("Health Specialist"),
  "Healthcare Administrator": _TL_("Healthcare Administrator"),
  "Heavy Equipment Supervisor": _TL_("Heavy Equipment Supervisor"),
  "Homemaker": _TL_("Homemaker"),
  "homemaker": _TL_("homemaker"),
  "Hospitality Professional": _TL_("Hospitality Professional"),
  "Human Resources Information System Consultant": _TL_("Human Resources Information System Consultant"),
  "Human Resources Legal Consultant": _TL_("Human Resources Legal Consultant"),
  "Human Resources Specialist": _TL_("Human Resources Specialist"),
  "Illustrator": _TL_("Illustrator"),
  "Industrial Designer": _TL_("Industrial Designer"),
  "Information Security Specialist": _TL_("Information Security Specialist"),
  "Information Technology Auditor": _TL_("Information Technology Auditor"),
  "Information Technology Consultant": _TL_("Information Technology Consultant"),
  "Information Technology Engineer": _TL_("Information Technology Engineer"),
  "Information Technology Support Specialist": _TL_("Information Technology Support Specialist"),
  "Information Technology System Administrator": _TL_("Information Technology System Administrator"),
  "Innovation Manager": _TL_("Innovation Manager"),
  "Institutional Investment Salesperson": _TL_("Institutional Investment Salesperson"),
  "Instructional Designer": _TL_("Instructional Designer"),
  "Insurance Agent": _TL_("Insurance Agent"),
  "Intellectual Property Specialist": _TL_("Intellectual Property Specialist"),
  "Interim Executive": _TL_("Interim Executive"),
  "interim executive": _TL_("interim executive"),
  "Interior Designer": _TL_("Interior Designer"),
  "International Trade Specialist": _TL_("International Trade Specialist"),
  "Investment Banking Analyst": _TL_("Investment Banking Analyst"),
  "Investment Portfolio Manager": _TL_("Investment Portfolio Manager"),
  "Investment Trader": _TL_("Investment Trader"),
  "Jeweler": _TL_("Jeweler"),
  "Journalist": _TL_("Journalist"),
  "Judge": _TL_("Judge"),
  "Laboratory Scientist": _TL_("Laboratory Scientist"),
  "Laboratory Technician": _TL_("Laboratory Technician"),
  "Laborer": _TL_("Laborer"),
  "laborer": _TL_("laborer"),
  "Landscape Designer": _TL_("Landscape Designer"),
  "Language and Localization Specialist": _TL_("Language and Localization Specialist"),
  "Lawyer": _TL_("Lawyer"),
  "Legal Administrative Professional": _TL_("Legal Administrative Professional"),
  "Legal Contract Administrator": _TL_("Legal Contract Administrator"),
  "Librarian": _TL_("Librarian"),
  "Life Sciences and Medical Researcher": _TL_("Life Sciences and Medical Researcher"),
  "Loan Officer": _TL_("Loan Officer"),
  "Logistics Specialist": _TL_("Logistics Specialist"),
  "Loss Prevention Specialist": _TL_("Loss Prevention Specialist"),
  "Managed Services Specialist": _TL_("Managed Services Specialist"),
  "Manufacturing Operations Manager": _TL_("Manufacturing Operations Manager"),
  "Mariner": _TL_("Mariner"),
  "Market Research Manager": _TL_("Market Research Manager"),
  "Marketing Communications Specialist": _TL_("Marketing Communications Specialist"),
  "Marketing Creative Designer": _TL_("Marketing Creative Designer"),
  "Marketing Operations Specialist": _TL_("Marketing Operations Specialist"),
  "Marketing Product Manager": _TL_("Marketing Product Manager"),
  "Marketing Project Manager": _TL_("Marketing Project Manager"),
  "Marketing Research Specialist": _TL_("Marketing Research Specialist"),
  "Marketing Specialist": _TL_("Marketing Specialist"),
  "Mechanic and Maintenance Tradesperson": _TL_("Mechanic and Maintenance Tradesperson"),
  "Medical Advisor": _TL_("Medical Advisor"),
  "Medical Assistant": _TL_("Medical Assistant"),
  "Medical Representative": _TL_("Medical Representative"),
  "Medical Research Advisor": _TL_("Medical Research Advisor"),
  "Medical Researcher": _TL_("Medical Researcher"),
  "Medical Salesperson": _TL_("Medical Salesperson"),
  "Medical Writer": _TL_("Medical Writer"),
  "Membership Director": _TL_("Membership Director"),
  "Mental Health Professional": _TL_("Mental Health Professional"),
  "Merchandiser": _TL_("Merchandiser"),
  "Military Officer": _TL_("Military Officer"),
  "Minister": _TL_("Minister"),
  "Motion Graphics Designer": _TL_("Motion Graphics Designer"),
  "Multimedia Specialist": _TL_("Multimedia Specialist"),
  "Music Manager": _TL_("Music Manager"),
  "Musician": _TL_("Musician"),
  "Network Engineer": _TL_("Network Engineer"),
  "New Home Salesperson": _TL_("New Home Salesperson"),
  "Non-profit Board Member": _TL_("Non-profit Board Member"),
  "Nurse": _TL_("Nurse"),
  "Occupational Therapist": _TL_("Occupational Therapist"),
  "Office Worker": _TL_("Office Worker"),
  "Online Marketing Manager": _TL_("Online Marketing Manager"),
  "Operations Specialist": _TL_("Operations Specialist"),
  "Packaging Specialist": _TL_("Packaging Specialist"),
  "Partner": _TL_("Partner"),
  "Payroll Specialist": _TL_("Payroll Specialist"),
  "Payroll Specialist Accounting": _TL_("Payroll Specialist Accounting"),
  "Pension Manager": _TL_("Pension Manager"),
  "Performer": _TL_("Performer"),
  "Personal Banker": _TL_("Personal Banker"),
  "Personal Stylist": _TL_("Personal Stylist"),
  "Personal Tax Specialist": _TL_("Personal Tax Specialist"),
  "Pet Services Specialist": _TL_("Pet Services Specialist"),
  "Pharmaceutical Scientist": _TL_("Pharmaceutical Scientist"),
  "Pharmacist": _TL_("Pharmacist"),
  "Photographer": _TL_("Photographer"),
  "Physical Therapist": _TL_("Physical Therapist"),
  "Physician": _TL_("Physician"),
  "Physicist": _TL_("Physicist"),
  "Political Staff": _TL_("Political Staff"),
  "Postal Worker": _TL_("Postal Worker"),
  "Pricing Specialist": _TL_("Pricing Specialist"),
  "Print Specialist": _TL_("Print Specialist"),
  "Process Specialist": _TL_("Process Specialist"),
  "Product Developer": _TL_("Product Developer"),
  "Product Development Engineer": _TL_("Product Development Engineer"),
  "Product Manager": _TL_("Product Manager"),
  "Product Researcher": _TL_("Product Researcher"),
  "Production Crew": _TL_("Production Crew"),
  "Production Editor": _TL_("Production Editor"),
  "Program Administrator": _TL_("Program Administrator"),
  "Program Analyst": _TL_("Program Analyst"),
  "Program Manager": _TL_("Program Manager"),
  "Project Administrator": _TL_("Project Administrator"),
  "Project Manager": _TL_("Project Manager"),
  "Property Manager": _TL_("Property Manager"),
  "Proposal Writer": _TL_("Proposal Writer"),
  "Public Health Specialist": _TL_("Public Health Specialist"),
  "Public Relations Specialist": _TL_("Public Relations Specialist"),
  "Public Safety Professional": _TL_("Public Safety Professional"),
  "Public Speaker": _TL_("Public Speaker"),
  "Publisher": _TL_("Publisher"),
  "Purchaser": _TL_("Purchaser"),
  "Quality Assurance Tester": _TL_("Quality Assurance Tester"),
  "Real Estate Broker": _TL_("Real Estate Broker"),
  "Real Estate Specialist": _TL_("Real Estate Specialist"),
  "Recreation Professional": _TL_("Recreation Professional"),
  "Recruiter": _TL_("Recruiter"),
  "Regulatory Specialist": _TL_("Regulatory Specialist"),
  "Reporter": _TL_("Reporter"),
  "Research Analyst": _TL_("Research Analyst"),
  "Research Development Software Engineer": _TL_("Research Development Software Engineer"),
  "research development software engineer": _TL_("research development software engineer"),
  "Research Fellow": _TL_("Research Fellow"),
  "Retail Salesperson": _TL_("Retail Salesperson"),
  "Retired": _TL_("Retired"),
  "retired": _TL_("retired"),
  "Revenue Manager": _TL_("Revenue Manager"),
  "Risk Management Specialist": _TL_("Risk Management Specialist"),
  "Safety Specialist": _TL_("Safety Specialist"),
  "Sales Engineer": _TL_("Sales Engineer"),
  "Sales Specialist": _TL_("Sales Specialist"),
  "Salesperson": _TL_("Salesperson"),
  "School Teacher": _TL_("School Teacher"),
  "Service Delivery Specialist": _TL_("Service Delivery Specialist"),
  "Social Media Specialist": _TL_("Social Media Specialist"),
  "Social Worker": _TL_("Social Worker"),
  "Software Developer": _TL_("Software Developer"),
  "Software Tester": _TL_("Software Tester"),
  "Staff Manager": _TL_("Staff Manager"),
  "Strategic Alliance Specialist": _TL_("Strategic Alliance Specialist"),
  "Student": _TL_("Student"),
  "Surgeon": _TL_("Surgeon"),
  "Surveyor": _TL_("Surveyor"),
  "Technical Sales Professional": _TL_("Technical Sales Professional"),
  "Technical Support Representative": _TL_("Technical Support Representative"),
  "Technical Writer": _TL_("Technical Writer"),
  "Technician": _TL_("Technician"),
  "Technology Instructor": _TL_("Technology Instructor"),
  "Technology Manager": _TL_("Technology Manager"),
  "Telecommunications Engineering Specialist": _TL_("Telecommunications Engineering Specialist"),
  "Telecommunications Specialist": _TL_("Telecommunications Specialist"),
  "Test Development Engineer": _TL_("Test Development Engineer"),
  "Tour Guide": _TL_("Tour Guide"),
  "tour guide": _TL_("tour guide"),
  "Transportation Specialist": _TL_("Transportation Specialist"),
  "Travel and Tourism Professional": _TL_("Travel and Tourism Professional"),
  "Treasurer": _TL_("Treasurer"),
  "Trust Officer": _TL_("Trust Officer"),
  "Underwriter": _TL_("Underwriter"),
  "University Professor": _TL_("University Professor"),
  "Urban Planner": _TL_("Urban Planner"),
  "User Experience Designer": _TL_("User Experience Designer"),
  "Volunteer": _TL_("Volunteer"),
  "volunteer": _TL_("volunteer"),
  "Wealth Manager": _TL_("Wealth Manager"),
  "Web Designer": _TL_("Web Designer"),
  "Website Manager": _TL_("Website Manager"),
  "Jobs & Education": _TL_("Jobs & Education"),
  "Education & Training": _TL_("Education & Training"),
  "Community & Continuing Education": _TL_("Community & Continuing Education"),
  "Law & Government": _TL_("Law & Government"),
  "Military": _TL_("Military"),
  "Politics": _TL_("Politics"),
  "Media": _TL_("Media"),
  "Audio Streaming Subscription Services": _TL_("Audio Streaming Subscription Services"),
  "Books": _TL_("Books"),
  "Video Games": _TL_("Video Games"),
  "Video Streaming Subscription Services": _TL_("Video Streaming Subscription Services"),
  "Musical Instruments & Accessories": _TL_("Musical Instruments & Accessories"),
  "News, Media & Publications": _TL_("News, Media & Publications"),
  "Books & Literature": _TL_("Books & Literature"),
  "E-Books": _TL_("E-Books"),
  "Celebrities & Entertainment News": _TL_("Celebrities & Entertainment News"),
  "Magazines & Magazine Subscriptions": _TL_("Magazines & Magazine Subscriptions"),
  "Newspapers": _TL_("Newspapers"),
  "Personal Services": _TL_("Personal Services"),
  "Commercial Properties": _TL_("Commercial Properties"),
  "Commercial Properties (For Rent)": _TL_("Commercial Properties (For Rent)"),
  "Commercial Properties (For Sale)": _TL_("Commercial Properties (For Sale)"),
  "Moving & Relocation": _TL_("Moving & Relocation"),
  "Bank-Owned & Foreclosed Listings": _TL_("Bank-Owned & Foreclosed Listings"),
  "Relocation & Household Moving": _TL_("Relocation & Household Moving"),
  "Apartments (For Rent)": _TL_("Apartments (For Rent)"),
  "Furnished Apartments": _TL_("Furnished Apartments"),
  "Unfurnished Apartments": _TL_("Unfurnished Apartments"),
  "Houses (For Rent)": _TL_("Houses (For Rent)"),
  "Residential Properties (For Sale)": _TL_("Residential Properties (For Sale)"),
  "Apartments (For Sale)": _TL_("Apartments (For Sale)"),
  "New Apartments (For Sale)": _TL_("New Apartments (For Sale)"),
  "Preowned Apartments (For Sale)": _TL_("Preowned Apartments (For Sale)"),
  "Houses (For Sale)": _TL_("Houses (For Sale)"),
  "New Houses (For Sale)": _TL_("New Houses (For Sale)"),
  "Preowned Houses (For Sale)": _TL_("Preowned Houses (For Sale)"),
  "Retailers & General Merchandise": _TL_("Retailers & General Merchandise"),
  "Coupons & Rebates": _TL_("Coupons & Rebates"),
  "Shopping Portals & Search Engines": _TL_("Shopping Portals & Search Engines"),
  "Wholesalers & Liquidators": _TL_("Wholesalers & Liquidators"),
  "Seasonal Shopping": _TL_("Seasonal Shopping"),
  "Back-to-School Shopping": _TL_("Back-to-School Shopping"),
  "Back-to-School Apparel & Accessories": _TL_("Back-to-School Apparel & Accessories"),
  "Black Friday Shopping": _TL_("Black Friday Shopping"),
  "In-Store Black Friday Shopping": _TL_("In-Store Black Friday Shopping"),
  "Online Black Friday Shopping": _TL_("Online Black Friday Shopping"),
  "Christmas Shopping": _TL_("Christmas Shopping"),
  "After-Christmas Sale Shopping": _TL_("After-Christmas Sale Shopping"),
  "In-Store Christmas Shopping": _TL_("In-Store Christmas Shopping"),
  "Online Christmas Shopping": _TL_("Online Christmas Shopping"),
  "India Independence Day": _TL_("India Independence Day"),
  "Mother's Day Shopping": _TL_("Mother's Day Shopping"),
  "Rakhi (Rakshabandhan) Festival": _TL_("Rakhi (Rakshabandhan) Festival"),
  "Valentine's Day Shopping": _TL_("Valentine's Day Shopping"),
  "Social": _TL_("Social"),
  "Dining & Nightlife Reviews, Guides & Listings": _TL_("Dining & Nightlife Reviews, Guides & Listings"),
  "Antivirus & Security Software": _TL_("Antivirus & Security Software"),
  "Audio & Music Software": _TL_("Audio & Music Software"),
  "Business Management Software": _TL_("Business Management Software"),
  "Design Software": _TL_("Design Software"),
  "Drawing & Animation Software": _TL_("Drawing & Animation Software"),
  "Photo Software": _TL_("Photo Software"),
  "Graphics & Multimedia Software": _TL_("Graphics & Multimedia Software"),
  "Tax & Accounting Software": _TL_("Tax & Accounting Software"),
  "Video Software": _TL_("Video Software"),
  "Boating & Water Recreation": _TL_("Boating & Water Recreation"),
  "Surfing & Windsurfing Gear": _TL_("Surfing & Windsurfing Gear"),
  "Fitness": _TL_("Fitness"),
  "Fitness Products & Services": _TL_("Fitness Products & Services"),
  "Exercise Equipment": _TL_("Exercise Equipment"),
  "Fitness Technology Products": _TL_("Fitness Technology Products"),
  "Weights & Strength Training Equipment": _TL_("Weights & Strength Training Equipment"),
  "Fitness Classes & Personal Training Services": _TL_("Fitness Classes & Personal Training Services"),
  "Gyms & Athletic Clubs": _TL_("Gyms & Athletic Clubs"),
  "Yoga & Pilates": _TL_("Yoga & Pilates"),
  "Outdoor Recreational Equipment": _TL_("Outdoor Recreational Equipment"),
  "Camping & Hiking Equipment": _TL_("Camping & Hiking Equipment"),
  "Fishing Equipment": _TL_("Fishing Equipment"),
  "Baseball Equipment": _TL_("Baseball Equipment"),
  "Golf Equipment": _TL_("Golf Equipment"),
  "Hockey Equipment": _TL_("Hockey Equipment"),
  "Skateboarding Equipment": _TL_("Skateboarding Equipment"),
  "Soccer Equipment": _TL_("Soccer Equipment"),
  "Water Activities Equipment & Accessories": _TL_("Water Activities Equipment & Accessories"),
  "Winter Sports Equipment & Accessories": _TL_("Winter Sports Equipment & Accessories"),
  "American Football": _TL_("American Football"),
  "Baseball": _TL_("Baseball"),
  "Basketball": _TL_("Basketball"),
  "College Sports": _TL_("College Sports"),
  "Cycling": _TL_("Cycling"),
  "Equestrian Sports": _TL_("Equestrian Sports"),
  "Golf": _TL_("Golf"),
  "Hunting & Shooting": _TL_("Hunting & Shooting"),
  "Motor Sports": _TL_("Motor Sports"),
  "Qatar 2022 football": _TL_("Qatar 2022 football"),
  "World Cup Fans": _TL_("World Cup Fans"),
  "Running & Walking": _TL_("Running & Walking"),
  "Soccer": _TL_("Soccer"),
  "Swimming & Aquatic Sports": _TL_("Swimming & Aquatic Sports"),
  "Tennis": _TL_("Tennis"),
  "Volleyball": _TL_("Volleyball"),
  "Winter Sports": _TL_("Winter Sports"),
  "Skiing": _TL_("Skiing"),
  "Snowboarding": _TL_("Snowboarding"),
  "Telecom": _TL_("Telecom"),
  "Cable & Satellite TV Providers": _TL_("Cable & Satellite TV Providers"),
  "Internet Service Providers": _TL_("Internet Service Providers"),
  "Mobile Phone Service Providers": _TL_("Mobile Phone Service Providers"),
  "Travel": _TL_("Travel"),
  "Travel & Tourism": _TL_("Travel & Tourism"),
  "Adventure Travel": _TL_("Adventure Travel"),
  "Ecotourism": _TL_("Ecotourism"),
  "Family Vacations & Travel": _TL_("Family Vacations & Travel"),
  "Tourist Attractions & Destinations": _TL_("Tourist Attractions & Destinations"),
  "Beaches & Islands": _TL_("Beaches & Islands"),
  "Lakes & Rivers": _TL_("Lakes & Rivers"),
  "Theme Parks": _TL_("Theme Parks"),
  "Hotels, Motels & Resorts": _TL_("Hotels, Motels & Resorts"),
  "Air Travel by Class": _TL_("Air Travel by Class"),
  "Business & First Class": _TL_("Business & First Class"),
  "Economy Class": _TL_("Economy Class"),
  "Air Travel by Destination": _TL_("Air Travel by Destination"),
  "Airline Tickets, Fares & Flights": _TL_("Airline Tickets, Fares & Flights"),
  "Bus & Rail Travel": _TL_("Bus & Rail Travel"),
  "Car Rental": _TL_("Car Rental"),
  "Economy, Compact & Mid-size Car Rental": _TL_("Economy, Compact & Mid-size Car Rental"),
  "Economy  Compact & Mid-size Car Rental": _TL_("Economy  Compact & Mid-size Car Rental"),
  "Full-size & Standard Car Rental": _TL_("Full-size & Standard Car Rental"),
  "Luxury, Convertible & Specialty Car Rental": _TL_("Luxury, Convertible & Specialty Car Rental"),
  "Luxury  Convertible & Specialty Car Rental": _TL_("Luxury  Convertible & Specialty Car Rental"),
  "Minivan & SUV Rental": _TL_("Minivan & SUV Rental"),
  "Cruises": _TL_("Cruises"),
  "Hotels & Accommodations": _TL_("Hotels & Accommodations"),
  "Hotels Motels and Resorts": _TL_("Hotels Motels and Resorts"),
  "Hotels by Star Rating": _TL_("Hotels by Star Rating"),
  "1 & 2 Star Hotels": _TL_("1 & 2 Star Hotels"),
  "3 Star Hotels": _TL_("3 Star Hotels"),
  "4 Star Hotels": _TL_("4 Star Hotels"),
  "5 Star Hotels": _TL_("5 Star Hotels"),
  "Last Minute Airfares & Flights": _TL_("Last Minute Airfares & Flights"),
  "Sightseeing Tours & Tourist Attractions": _TL_("Sightseeing Tours & Tourist Attractions"),
  "Transportation & Excursions": _TL_("Transportation & Excursions"),
  "Travel Media & Publications": _TL_("Travel Media & Publications"),
  "City & Local Guides": _TL_("City & Local Guides"),
  "Trips by Destination": _TL_("Trips by Destination"),
  "Trips to Asia-Pacific": _TL_("Trips to Asia-Pacific"),
  "Trips to Australia": _TL_("Trips to Australia"),
  "Trips to Brisbane": _TL_("Trips to Brisbane"),
  "Trips to Melbourne": _TL_("Trips to Melbourne"),
  "Trips to Perth": _TL_("Trips to Perth"),
  "Trips to Sydney": _TL_("Trips to Sydney"),
  "Trips to China": _TL_("Trips to China"),
  "Trips to Beijing": _TL_("Trips to Beijing"),
  "Trips to Chengdu": _TL_("Trips to Chengdu"),
  "Trips to Guangzhou": _TL_("Trips to Guangzhou"),
  "Trips to Shanghai": _TL_("Trips to Shanghai"),
  "Trips to Hong Kong": _TL_("Trips to Hong Kong"),
  "Trips to India": _TL_("Trips to India"),
  "Trips to Ahmedabad": _TL_("Trips to Ahmedabad"),
  "Trips to Bangalore": _TL_("Trips to Bangalore"),
  "Trips to Chennai": _TL_("Trips to Chennai"),
  "Trips to Delhi": _TL_("Trips to Delhi"),
  "Trips to Goa": _TL_("Trips to Goa"),
  "Trips to Hyderabad": _TL_("Trips to Hyderabad"),
  "Trips to Jaipur": _TL_("Trips to Jaipur"),
  "Trips to Kochi (India)": _TL_("Trips to Kochi (India)"),
  "Trips to Kolkata": _TL_("Trips to Kolkata"),
  "Trips to Mumbai": _TL_("Trips to Mumbai"),
  "Trips to Pune": _TL_("Trips to Pune"),
  "Trips to Indonesia": _TL_("Trips to Indonesia"),
  "Trips to Bali": _TL_("Trips to Bali"),
  "Trips to Bandung": _TL_("Trips to Bandung"),
  "Trips to Jakarta": _TL_("Trips to Jakarta"),
  "Trips to Japan": _TL_("Trips to Japan"),
  "Trips to Fukuoka": _TL_("Trips to Fukuoka"),
  "Trips to Kyoto-Osaka-Kobe": _TL_("Trips to Kyoto-Osaka-Kobe"),
  "Trips to Nagoya": _TL_("Trips to Nagoya"),
  "Trips to Okinawa": _TL_("Trips to Okinawa"),
  "Trips to Sapporo": _TL_("Trips to Sapporo"),
  "Trips to Tokyo": _TL_("Trips to Tokyo"),
  "Trips to Malaysia": _TL_("Trips to Malaysia"),
  "Trips to Kuala Lumpur": _TL_("Trips to Kuala Lumpur"),
  "Trips to Penang": _TL_("Trips to Penang"),
  "Trips to Nepal": _TL_("Trips to Nepal"),
  "Trips to New Zealand": _TL_("Trips to New Zealand"),
  "Trips to Seoul": _TL_("Trips to Seoul"),
  "Trips to Singapore": _TL_("Trips to Singapore"),
  "Trips to Sri Lanka": _TL_("Trips to Sri Lanka"),
  "Trips to Taipei": _TL_("Trips to Taipei"),
  "Trips to Thailand": _TL_("Trips to Thailand"),
  "Trips to Bangkok": _TL_("Trips to Bangkok"),
  "Trips to Chiang Mai": _TL_("Trips to Chiang Mai"),
  "Trips to Phuket": _TL_("Trips to Phuket"),
  "Trips to the Philippines": _TL_("Trips to the Philippines"),
  "Trips to Vietnam": _TL_("Trips to Vietnam"),
  "Trips to Hanoi": _TL_("Trips to Hanoi"),
  "Trips to Ho Chi Minh City": _TL_("Trips to Ho Chi Minh City"),
  "Trips to Europe": _TL_("Trips to Europe"),
  "Trips to Amsterdam": _TL_("Trips to Amsterdam"),
  "Trips to Brussels": _TL_("Trips to Brussels"),
  "Trips to Croatia": _TL_("Trips to Croatia"),
  "Trips to Denmark": _TL_("Trips to Denmark"),
  "Trips to Copenhagen": _TL_("Trips to Copenhagen"),
  "Trips to France": _TL_("Trips to France"),
  "Trips to Bordeaux": _TL_("Trips to Bordeaux"),
  "Trips to Lyon": _TL_("Trips to Lyon"),
  "Trips to Marseille": _TL_("Trips to Marseille"),
  "Trips to Nice": _TL_("Trips to Nice"),
  "Trips to Paris": _TL_("Trips to Paris"),
  "Trips to Toulouse": _TL_("Trips to Toulouse"),
  "Trips to Germany": _TL_("Trips to Germany"),
  "Trips to Berlin": _TL_("Trips to Berlin"),
  "Trips to Cologne": _TL_("Trips to Cologne"),
  "Trips to Dusseldorf": _TL_("Trips to Dusseldorf"),
  "Trips to Frankfurt": _TL_("Trips to Frankfurt"),
  "Trips to Hamburg": _TL_("Trips to Hamburg"),
  "Trips to Munich": _TL_("Trips to Munich"),
  "Trips to Stuttgart": _TL_("Trips to Stuttgart"),
  "Trips to Greece": _TL_("Trips to Greece"),
  "Trips to Helsinki": _TL_("Trips to Helsinki"),
  "Trips to Hungary": _TL_("Trips to Hungary"),
  "Trips to Budapest": _TL_("Trips to Budapest"),
  "Trips to Iceland": _TL_("Trips to Iceland"),
  "Trips to Ireland": _TL_("Trips to Ireland"),
  "Trips to Dublin": _TL_("Trips to Dublin"),
  "Trips to Italy": _TL_("Trips to Italy"),
  "Trips to Bologna": _TL_("Trips to Bologna"),
  "Trips to Florence": _TL_("Trips to Florence"),
  "Trips to Milan": _TL_("Trips to Milan"),
  "Trips to Naples": _TL_("Trips to Naples"),
  "Trips to Rome": _TL_("Trips to Rome"),
  "Trips to Sicily": _TL_("Trips to Sicily"),
  "Trips to Venice": _TL_("Trips to Venice"),
  "Trips to Kiev": _TL_("Trips to Kiev"),
  "Trips to Malta": _TL_("Trips to Malta"),
  "Trips to Moscow": _TL_("Trips to Moscow"),
  "Trips to Oslo": _TL_("Trips to Oslo"),
  "Trips to Poland": _TL_("Trips to Poland"),
  "Trips to Krakow": _TL_("Trips to Krakow"),
  "Trips to Warsaw": _TL_("Trips to Warsaw"),
  "Trips to Portugal": _TL_("Trips to Portugal"),
  "Trips to Faro": _TL_("Trips to Faro"),
  "Trips to Lisbon": _TL_("Trips to Lisbon"),
  "Trips to Porto": _TL_("Trips to Porto"),
  "Trips to Prague": _TL_("Trips to Prague"),
  "Trips to Romania": _TL_("Trips to Romania"),
  "Trips to Sofia": _TL_("Trips to Sofia"),
  "Trips to Spain": _TL_("Trips to Spain"),
  "Trips to Alicante": _TL_("Trips to Alicante"),
  "Trips to Barcelona": _TL_("Trips to Barcelona"),
  "Trips to Bilbao": _TL_("Trips to Bilbao"),
  "Trips to Cordoba": _TL_("Trips to Cordoba"),
  "Trips to Granada": _TL_("Trips to Granada"),
  "Trips to Madrid": _TL_("Trips to Madrid"),
  "Trips to Malaga": _TL_("Trips to Malaga"),
  "Trips to Mallorca, Ibiza & Balearic Islands": _TL_("Trips to Mallorca, Ibiza & Balearic Islands"),
  "Trips to Seville": _TL_("Trips to Seville"),
  "Trips to the Canary Islands": _TL_("Trips to the Canary Islands"),
  "Trips to Valencia": _TL_("Trips to Valencia"),
  "Trips to St. Petersburg": _TL_("Trips to St. Petersburg"),
  "Trips to Sweden": _TL_("Trips to Sweden"),
  "Trips to Stockholm": _TL_("Trips to Stockholm"),
  "Trips to Switzerland": _TL_("Trips to Switzerland"),
  "Trips to Geneva": _TL_("Trips to Geneva"),
  "Trips to Zurich": _TL_("Trips to Zurich"),
  "Trips to the UK": _TL_("Trips to the UK"),
  "Trips to Birmingham, UK": _TL_("Trips to Birmingham, UK"),
  "Trips to Edinburgh": _TL_("Trips to Edinburgh"),
  "Trips to Glasgow": _TL_("Trips to Glasgow"),
  "Trips to London, UK": _TL_("Trips to London, UK"),
  "Trips to Manchester, UK": _TL_("Trips to Manchester, UK"),
  "Trips to Turkey": _TL_("Trips to Turkey"),
  "Trips to Ankara": _TL_("Trips to Ankara"),
  "Trips to Antalya": _TL_("Trips to Antalya"),
  "Trips to Istanbul": _TL_("Trips to Istanbul"),
  "Trips to Izmir": _TL_("Trips to Izmir"),
  "Trips to Vienna": _TL_("Trips to Vienna"),
  "Trips to Latin America": _TL_("Trips to Latin America"),
  "Trips to Bogota": _TL_("Trips to Bogota"),
  "Trips to Brazil": _TL_("Trips to Brazil"),
  "Trips to Rio de Janeiro": _TL_("Trips to Rio de Janeiro"),
  "Trips to Salvador": _TL_("Trips to Salvador"),
  "Trips to São Paulo": _TL_("Trips to São Paulo"),
  "Trips to Buenos Aires": _TL_("Trips to Buenos Aires"),
  "Trips to Costa Rica": _TL_("Trips to Costa Rica"),
  "Trips to Guatemala": _TL_("Trips to Guatemala"),
  "Trips to Lima": _TL_("Trips to Lima"),
  "Trips to Mexico": _TL_("Trips to Mexico"),
  "Trips to Acapulco": _TL_("Trips to Acapulco"),
  "Trips to Cancun & Playa del Carmen": _TL_("Trips to Cancun & Playa del Carmen"),
  "Trips to Guadalajara": _TL_("Trips to Guadalajara"),
  "Trips to Los Cabos": _TL_("Trips to Los Cabos"),
  "Trips to Mexico City": _TL_("Trips to Mexico City"),
  "Trips to Monterrey": _TL_("Trips to Monterrey"),
  "Trips to Puerto Vallarta": _TL_("Trips to Puerto Vallarta"),
  "Trips to Panama": _TL_("Trips to Panama"),
  "Trips to Santiago": _TL_("Trips to Santiago"),
  "Trips to the Caribbean": _TL_("Trips to the Caribbean"),
  "Trips to Aruba": _TL_("Trips to Aruba"),
  "Trips to Cuba": _TL_("Trips to Cuba"),
  "Trips to Jamaica": _TL_("Trips to Jamaica"),
  "Trips to Nassau": _TL_("Trips to Nassau"),
  "Trips to Puerto Rico": _TL_("Trips to Puerto Rico"),
  "Trips to the Dominican Republic": _TL_("Trips to the Dominican Republic"),
  "Trips to North America": _TL_("Trips to North America"),
  "Trips to Canada": _TL_("Trips to Canada"),
  "Trips to Calgary": _TL_("Trips to Calgary"),
  "Trips to Montreal": _TL_("Trips to Montreal"),
  "Trips to Ottawa": _TL_("Trips to Ottawa"),
  "Trips to Toronto": _TL_("Trips to Toronto"),
  "Trips to Vancouver": _TL_("Trips to Vancouver"),
  "Trips to the US": _TL_("Trips to the US"),
  "Trips to Alaska": _TL_("Trips to Alaska"),
  "Trips to Albuquerque": _TL_("Trips to Albuquerque"),
  "Trips to Atlanta": _TL_("Trips to Atlanta"),
  "Trips to Atlantic City": _TL_("Trips to Atlantic City"),
  "Trips to Austin": _TL_("Trips to Austin"),
  "Trips to Baltimore": _TL_("Trips to Baltimore"),
  "Trips to Birmingham, AL": _TL_("Trips to Birmingham, AL"),
  "Trips to Boston": _TL_("Trips to Boston"),
  "Trips to Buffalo-Rochester Area": _TL_("Trips to Buffalo-Rochester Area"),
  "Trips to California": _TL_("Trips to California"),
  "Trips to Los Angeles": _TL_("Trips to Los Angeles"),
  "Trips to Orange County, CA": _TL_("Trips to Orange County, CA"),
  "Trips to San Diego": _TL_("Trips to San Diego"),
  "Trips to San Francisco Bay Area": _TL_("Trips to San Francisco Bay Area"),
  "Trips to Charleston, SC": _TL_("Trips to Charleston, SC"),
  "Trips to Charlotte": _TL_("Trips to Charlotte"),
  "Trips to Chicago": _TL_("Trips to Chicago"),
  "Trips to Cincinnati": _TL_("Trips to Cincinnati"),
  "Trips to Cleveland": _TL_("Trips to Cleveland"),
  "Trips to Columbus": _TL_("Trips to Columbus"),
  "Trips to Dallas-Fort Worth": _TL_("Trips to Dallas-Fort Worth"),
  "Trips to Denver": _TL_("Trips to Denver"),
  "Trips to Detroit": _TL_("Trips to Detroit"),
  "Trips to Florida": _TL_("Trips to Florida"),
  "Trips to Fort Lauderdale": _TL_("Trips to Fort Lauderdale"),
  "Trips to Fort Myers": _TL_("Trips to Fort Myers"),
  "Trips to Jacksonville": _TL_("Trips to Jacksonville"),
  "Trips to Key West": _TL_("Trips to Key West"),
  "Trips to Miami": _TL_("Trips to Miami"),
  "Trips to Orlando": _TL_("Trips to Orlando"),
  "Trips to Pensacola": _TL_("Trips to Pensacola"),
  "Trips to Tampa Bay Area": _TL_("Trips to Tampa Bay Area"),
  "Trips to Gatlinburg": _TL_("Trips to Gatlinburg"),
  "Trips to Greenville, SC": _TL_("Trips to Greenville, SC"),
  "Trips to Hartford": _TL_("Trips to Hartford"),
  "Trips to Hawaii": _TL_("Trips to Hawaii"),
  "Trips to Maui": _TL_("Trips to Maui"),
  "Trips to Oahu": _TL_("Trips to Oahu"),
  "Trips to the Big Island": _TL_("Trips to the Big Island"),
  "Trips to Houston": _TL_("Trips to Houston"),
  "Trips to Indianapolis": _TL_("Trips to Indianapolis"),
  "Trips to Kansas City": _TL_("Trips to Kansas City"),
  "Trips to Las Vegas": _TL_("Trips to Las Vegas"),
  "Trips to Little Rock": _TL_("Trips to Little Rock"),
  "Trips to Louisville": _TL_("Trips to Louisville"),
  "Trips to Memphis": _TL_("Trips to Memphis"),
  "Trips to Milwaukee": _TL_("Trips to Milwaukee"),
  "Trips to Minneapolis-Saint Paul": _TL_("Trips to Minneapolis-Saint Paul"),
  "Trips to Myrtle Beach & Grand Strand": _TL_("Trips to Myrtle Beach & Grand Strand"),
  "Trips to Nashville": _TL_("Trips to Nashville"),
  "Trips to New Orleans": _TL_("Trips to New Orleans"),
  "Trips to New York City": _TL_("Trips to New York City"),
  "Trips to Norfolk-Virginia Beach Region": _TL_("Trips to Norfolk-Virginia Beach Region"),
  "Trips to Ocean City, MD": _TL_("Trips to Ocean City, MD"),
  "Trips to Oklahoma City": _TL_("Trips to Oklahoma City"),
  "Trips to Omaha": _TL_("Trips to Omaha"),
  "Trips to Philadelphia": _TL_("Trips to Philadelphia"),
  "Trips to Phoenix": _TL_("Trips to Phoenix"),
  "Trips to Pittsburgh": _TL_("Trips to Pittsburgh"),
  "Trips to Portland, OR": _TL_("Trips to Portland, OR"),
  "Trips to Raleigh-Durham Area": _TL_("Trips to Raleigh-Durham Area"),
  "Trips to Reno": _TL_("Trips to Reno"),
  "Trips to Richmond, VA": _TL_("Trips to Richmond, VA"),
  "Trips to Salt Lake City": _TL_("Trips to Salt Lake City"),
  "Trips to San Antonio": _TL_("Trips to San Antonio"),
  "Trips to Savannah": _TL_("Trips to Savannah"),
  "Trips to Seattle": _TL_("Trips to Seattle"),
  "Trips to St. Louis": _TL_("Trips to St. Louis"),
  "Trips to Tucson": _TL_("Trips to Tucson"),
  "Trips to Washington, D.C.": _TL_("Trips to Washington, D.C."),
  "Trips to the Middle East & Africa": _TL_("Trips to the Middle East & Africa"),
  "Trips to Doha": _TL_("Trips to Doha"),
  "Trips to Egypt": _TL_("Trips to Egypt"),
  "Trips to Israel": _TL_("Trips to Israel"),
  "Trips to Jeddah": _TL_("Trips to Jeddah"),
  "Trips to Jordan": _TL_("Trips to Jordan"),
  "Trips to Kenya": _TL_("Trips to Kenya"),
  "Trips to Kuwait": _TL_("Trips to Kuwait"),
  "Trips to Lebanon": _TL_("Trips to Lebanon"),
  "Trips to Morocco": _TL_("Trips to Morocco"),
  "Trips to Riyadh": _TL_("Trips to Riyadh"),
  "Trips to South Africa": _TL_("Trips to South Africa"),
  "Trips to Cape Town": _TL_("Trips to Cape Town"),
  "Trips to Johannesburg": _TL_("Trips to Johannesburg"),
  "Trips to Tehran": _TL_("Trips to Tehran"),
  "Trips to the United Arab Emirates": _TL_("Trips to the United Arab Emirates"),
  "Trips to Abu Dhabi": _TL_("Trips to Abu Dhabi"),
  "Trips to Dubai": _TL_("Trips to Dubai"),
  "Vacation Packages": _TL_("Vacation Packages"),
  "Vehicle Tires & Tire Parts": _TL_("Vehicle Tires & Tire Parts"),
};
